<template>
  <div>
    <main-header />
    <v-fade-transition mode="out-in">
      <router-view />
    </v-fade-transition>
    <main-footer />
  </div>
</template>

<script>
const MainHeader = () => import(/* webpackChunkName: "MainHeader" */ '@/components/shared/MainHeader.vue')
const UserProductFooter = () => import(/* webpackChunkName: "UserProductFooter" */ '@/components/MainFooter.vue')

export default {
  components: {
    'main-header': MainHeader,
    'main-footer': UserProductFooter,
  },
}
</script>
